/**
 * QuickAnswer — TL;DR call-out block + QAPage / Speakable schema.
 *
 * Mount under H1 on any page that has a canonical answerable question.
 * The visible block reads like a featured-snippet — Google AI Overview,
 * Bing Copilot, Perplexity, and Claude search treat this format as
 * citation-ready when paired with the QAPage + Speakable structured
 * data emitted alongside (already wired in the caller's schemas array).
 *
 * Props:
 *   question  — the canonical search query this page answers
 *   answer    — 50-90 word direct answer (plain prose, no markdown)
 *   testidPrefix — for E2E selectors (e.g. "strain-quick-answer")
 */
export default function QuickAnswer({ question, answer, testidPrefix = "quick-answer" }) {
    if (!question || !answer) return null;
    return (
        <section
            data-testid={testidPrefix}
            className="bg-zen-cream-soft border-l-4 border-zen-olive max-w-3xl px-6 py-5 my-6 shadow-sm"
            aria-label="Quick answer"
        >
            <p
                data-testid={`${testidPrefix}-question`}
                className="text-[11px] uppercase tracking-[0.3em] text-zen-olive mb-2"
            >
                Quick answer · {question}
            </p>
            <p
                data-testid={`${testidPrefix}-answer`}
                className="text-[16px] sm:text-[17px] text-zen-ink leading-[1.7] font-serif"
            >
                {answer}
            </p>
        </section>
    );
}
